import React from 'react'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import styles from './AboutMedicalHarbour.module.css'

const AboutMedicalHarbour = () => {
  const { t } = useTranslation()

  return (
    <div className="mw-unsigned mx-auto">
      <section className={styles.wrapper}>
        <div className={styles.topRow}>
          <Image
            src="/assets/images/logo-medical-harbour.png"
            alt="Logo Medical Harbour"
            width={100}
            height={100}
            className={styles.logo}
          />
          <span className={styles.text}>
            {t('subtitles.aboutMedicalHarbour1')}
            <br />
            {t('subtitles.aboutMedicalHarbour2')}
            <br />
            {t('subtitles.aboutMedicalHarbour3')}
          </span>
        </div>
        <div className={styles.logosRow}>
          <Image
            src="/assets/images/logo-bioatlas.png"
            alt="Logo BioAtlas"
            width={140}
            height={50}
            className={styles.partnerLogo}
          />
          <Image
            src="/assets/images/logo-bioatlasvet.png"
            alt="Logo BioAtlasVet"
            width={140}
            height={50}
            className={styles.partnerLogo}
          />
          <Image
            src="/assets/images/logo-athena-hub.png"
            alt="Logo Athena Hub"
            width={140}
            height={50}
            className={styles.partnerLogo}
          />
        </div>
      </section>
    </div>
  )
}

export default AboutMedicalHarbour
